<app-navigation-header title="Clients" i18n-title="@@clientMainTab-Clients">
	<app-client-list-table [appBreadcrumbLabel]="clientListBreadcrumbLabel"></app-client-list-table>
</app-navigation-header>
